import { css } from '@emotion/react';

export default css`
  width: 50px;
  height: 50px;
`;